import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VideoGallery from '@/components/shared/VideoGallery';

/**
 * 媒體訊息渲染（無氣泡，由 ChatPage 包裹）
 * - 圖片/影片：轉換成 VideoGallery 格式，支援燈箱與 stream_status overlay
 * - 過期：icon + 插值文字
 *
 * @param {{ media: Array }} props
 *   media item: { id, type: "image"|"video", file_url, is_expired, expired_at,
 *                 stream_uid?, stream_status?, playback_url?, thumbnail_url? }
 */
const ChatMediaMessage = ({ media, isSelf = false }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column gap-2">
      {media.map((item, index) => {
        if (item.is_expired) {
          const bubbleClass = `${isSelf ? 'msg-me' : 'msg-other'} rounded-4 px-3 py-2`;
          return (
            <div key={item.id ?? index} className={isSelf ? 'd-flex justify-content-end' : ''}>
              <div className={bubbleClass}>
                <p className="mb-0 text-gray">
                  <FontAwesomeIcon icon={['fas', item.type === 'video' ? 'video' : 'image']} className="me-1" />
                  {t('media_expired', { type: t(item.type === 'video' ? 'video' : 'image') })}
                </p>
              </div>
            </div>
          );
        }

        const galleryItem = {
          id: item.id ?? index,
          type: item.type === 'video' ? 1 : 0,
          url: item.file_url,
          big_url: item.file_url,
          thumbnail_url: item.type === 'video' ? item.thumbnail_url : item.file_url,
          playback_url: item.playback_url,
          stream_status: item.stream_status,
        };

        return (
          <div key={item.id ?? index}>
            <VideoGallery images={[galleryItem]} />
          </div>
        );
      })}
    </div>
  );
};

export default ChatMediaMessage;
